/* ========================================================================== *\
___________       __         .__
\_   _____/ _____/  |________|__| ____
 |    __)_ /    \   __\_  __ \  |/  _ \
 |        \   |  \  |  |  | \/  (  <_> )
/_______  /___|  /__|  |__|  |__|\____/
        \/     \/
\* ========================================================================== */
import { dateTimeDisplay } from 'services/Function';

/* ข้อความเครดิตบนการ์ดงานภาพ — สั้นที่สุด (รอบตัดคำ 6 ต.ค. 2569): รอ = ประมาณ · เสร็จ = ยอดจริง · ใส่รหัส = ฟรี */
export default function jobCreditText(row, types) {
  if (row.job_type === 'SKU_STAMP') return 'ฟรี';
  const type = types.find((item) => item.id === row.job_type);
  const used = Number(row.credits_used) || 0;
  if (['QUEUED', 'PROCESSING'].includes(row.status)) return `ประมาณ ${type?.credits ?? '-'} เครดิต`;
  return used > 0 ? `${used} เครดิต` : '';
}

/* เหตุผลภาษาไทยของรหัส error — ชุดเดียวกับแผนที่ใน scripts/worker_image_job.php (16 ต.ค. 2569)
   ใช้ทั้งการ์ดงานที่ไม่สำเร็จและ toast · รหัสที่ไม่รู้จักคืน '' ให้ผู้เรียกใช้ข้อความกลางเอง */
const JOB_REASONS = {
  not_owner: 'งานนี้เป็นของคนอื่น — จัดการได้เฉพาะคนสั่งงานหรือผู้ดูแลระบบ AI',
  input_file_not_found: 'ไม่พบไฟล์รูปต้นทาง',
  ai_source_file_not_found: 'ไม่พบไฟล์รูปต้นทาง',
  ai_source_file_too_large: 'รูปต้นทางไฟล์ใหญ่เกินไป (ไม่เกิน 4MB)',
  ai_api_key_missing: 'ร้านยังไม่ได้เชื่อมต่อผู้ให้บริการ AI — แจ้งไอที',
  ai_quota_exceeded: 'เกินโควตา AI ประจำเดือนแล้ว',
  ai_user_quota_exceeded: 'เครดิต AI เดือนนี้ของคุณครบตามที่ผู้ดูแลตั้งไว้แล้ว — ติดต่อผู้ดูแลระบบ',
  ai_quota_would_exceed: 'โควตา AI เดือนนี้เหลือไม่พอสำหรับงานนี้',
  ai_quota_not_set:
    'AI ปิดทั้งร้านอยู่ (โควตาเป็น 0) — ผู้ดูแลระบบตั้งโควตาได้ที่เมนู AI · ค่าใช้จ่ายและโควตา',
  ai_kill_switch_on:
    'AI ปิดทั้งร้านอยู่ (หยุดฉุกเฉิน) — เปิดกลับได้ที่เมนู AI · ค่าใช้จ่ายและโควตา',
  ai_upload_failed: 'ส่งรูปให้ผู้ให้บริการ AI ไม่สำเร็จ',
  ai_create_failed: 'ผู้ให้บริการ AI รับงานไม่สำเร็จ',
  ai_download_failed: 'โหลดภาพผลลัพธ์ไม่สำเร็จ',
  ai_result_invalid: 'ไฟล์ผลลัพธ์จาก AI ไม่ใช่รูปภาพ',
  ai_timeout: 'AI ใช้เวลานานเกิน 5 นาที — กดทำใหม่ได้',
  provider_clean_unavailable: 'ยังไม่ได้ตั้งค่าผู้ให้บริการ AI',
  provider_bg_unavailable: 'ยังไม่ได้ตั้งค่าผู้ให้บริการ AI',
  image_open_failed: 'เปิดไฟล์รูปไม่ได้',
  image_save_failed: 'บันทึกไฟล์รูปไม่สำเร็จ',
  sku_empty: 'สินค้าไม่มีรหัส SKU',
  permission_denied: 'บัญชีนี้ไม่มีสิทธิ์สั่งงานภาพ',
  no_source_image: 'สินค้านี้ยังไม่มีภาพให้ประมวลผล',
  gallery_file_exists: 'ชื่อไฟล์ซ้ำ กดเก็บอีกครั้ง',
  copy_failed: 'คัดลอกไฟล์ภาพไม่สำเร็จ',
  /* รหัสจาก controllers/image_job.con.php ที่เดิมตกไปข้อความกลาง (18 ต.ค. 2569) */
  job_result_not_ready: 'ภาพของงานนี้ยังไม่พร้อม รอสักครู่แล้วลองใหม่',
  pending_image_not_found: 'ไม่พบภาพที่รอเก็บของงานนี้',
  already_approved: 'ภาพนี้อยู่ในแกลเลอรีแล้ว',
  job_not_waiting: 'ภาพนี้ไม่ได้รอตรวจรับแล้ว (เก็บหรือไม่ใช้ไปแล้ว)',
  no_valid_image: 'สินค้าที่เลือกไม่มีรูปให้ทำงาน',
  product_id_required: 'ไม่พบสินค้า',
  job_not_found: 'ไม่พบงานนี้แล้ว โหลดหน้าใหม่',
  job_not_queued: 'งานนี้เริ่มทำแล้ว',
  job_not_failed: 'สถานะงานเปลี่ยนแล้ว โหลดหน้าใหม่',
  job_processing: 'งานนี้เริ่มทำแล้ว ยกเลิกไม่ได้',
  bulk_too_many: 'สั่งได้ครั้งละไม่เกิน 200 รูป',
  upload_failed: 'ส่งรูปให้ผู้ให้บริการ AI ไม่สำเร็จ',
  stamp_failed: 'ใส่รหัสสินค้าไม่สำเร็จ',
  ai_provider_not_found: 'ยังไม่ได้ตั้งค่าผู้ให้บริการ AI',
  ai_provider_not_loaded: 'ยังไม่ได้ตั้งค่าผู้ให้บริการ AI',
};

export function jobErrorText(code) {
  const key = String(code || '');
  if (JOB_REASONS[key]) return JOB_REASONS[key];
  if (key.startsWith('ai_clean_')) return 'AI เก็บงานไม่สำเร็จ';
  if (key.startsWith('bg_remove_')) return 'ลบพื้นหลังไม่สำเร็จ';
  if (key.startsWith('timeout')) return 'ค้างเกิน 30 นาที';
  return '';
}

/* วันเวลาบนการ์ดงาน dd/mm/yyyy HH:MM ตามรูปแบบของ ERP · withSeconds ใช้ใน title (18 ต.ค. 2569) */
export function jobDateText(value, withSeconds = false) {
  const raw = String(value || '');
  if (!raw) return '-';
  const text = dateTimeDisplay(raw.replace(' ', 'T'));
  if (!text) return raw;
  return withSeconds && raw.length >= 19 ? `${text}${raw.slice(16, 19)}` : text;
}
